module.exports = new __parcel__URL__("jpd-timeline-blank.ee712d03.svg").toString();